import Utils from './Utils';

interface OptionalConfig {
    allowAnchor?: boolean;
    campaign?: {
        source: string | null;
        medium: string | null;
        content: string | null;
        name: string | null;
    };
    [key: string]: unknown;
}

export const install = (trackingId: string, optionalConfig: OptionalConfig) => {
    const scriptId = 'ga-gtag4';
    // @ts-ignore
    const utmParams = JSON.parse(localStorage.getItem('urlParams')) || {
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_content: null,
    };

    const defaultConfig = {
        allowAnchor: true,
        campaign: {
            source: utmParams.utm_source,
            medium: utmParams.utm_medium,
            content: utmParams.utm_content,
            name: utmParams.utm_campaign,
        },
    };

    if (document.getElementById(scriptId)) return;

    const { head } = document;
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}&l=dataLayer4`;
    head.insertBefore(script, head.firstChild);

    window.dataLayer4 = window.dataLayer4 || [];

    const { googleAdsId = null, googleAdsShopId = null, ...restOptionalConfig } = { ...(optionalConfig ?? {}) };

    gtag('js', Utils.getUTCDate());
    gtag('config', trackingId, { ...defaultConfig, ...restOptionalConfig });

    if (googleAdsId && googleAdsShopId) {
        gtag('config', googleAdsId);
    }
};

export const gtag: any = function () {
    // Can't use arrow func + destructuring as Google expects
    // arguments objectas in dataLayer (not an array of arguments).
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer4.push(arguments);
};
export const generateStringifyQueryParams = async () => {
    const params = Utils.getUrlParams();

    const searchParams = new URLSearchParams();

    Object.keys(params).forEach((key) => searchParams.append(key, params[key]));

    return searchParams.toString();
};
